module.exports = __webpack_public_path__ + "static/aq-info-fresh-286cc1082b826d4bcfacdeb0a18ee6f3.png";